<div class="join-chat-container">
  <div class="join-chat-inner-container" *ngIf="canJoinChat && participantsLoaded">
    <button *ngIf="!isChatJoined && !isChatOwn"
            class="btn btn-light join-chat-button"
            (click)="joinChat()"
            [disabled]="joinInProgress"
            [attr.data-automation-id]="'bc-join-chat-button'">
      <span>{{ 'joinChat.buttons.join' | translate }}</span>
    </button>

    <app-editor *ngIf="isEditorVisible()"
                (onEditorSubmit)="onEditorSubmit($event)"
                (editorSetupDone)="onEditorSetupDone($event)"
                [(editorContentModel)]="editorContent.text"
                [editorInitSetting]="editorInitSetting"
                [submitOnEnter]="true">
    </app-editor>
    <app-auto-save [model]="editorContent" [storageKey]="editorAutoSaveStorageKey"></app-auto-save>
    <button *ngIf="isChatJoined && !isChatOwn" class="btn btn-light leave-chat-button" (click)="leaveChat()"
            [disabled]="leaveInProgress">
      <span>{{ 'joinChat.buttons.leave' | translate }}</span>
    </button>
  </div>
</div>
